import React from 'react'

const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill="none">
        <g clipPath="url(#clip0_14850_9694)">
            <path d="M13.8406 13.0708L10.4239 9.65421C11.2731 8.63294 11.7848 7.32151 11.7848 5.89258C11.7848 2.6434 9.14147 0 5.89243 0C2.64333 0 0 2.6434 0 5.89258C0 9.14154 2.64333 11.7847 5.89243 11.7847C7.32129 11.7847 8.63279 11.2731 9.65407 10.4239L13.0708 13.8406C13.1771 13.9469 13.3164 14 13.4557 14C13.595 14 13.7343 13.9469 13.8406 13.8406C14.0532 13.628 14.0532 13.2834 13.8406 13.0708ZM1.08862 5.89258C1.08862 3.24367 3.24359 1.08862 5.89243 1.08862C8.5412 1.08862 10.6961 3.24367 10.6961 5.89258C10.6961 8.54127 8.5412 10.6961 5.89243 10.6961C3.24359 10.6961 1.08862 8.54127 1.08862 5.89258Z" fill="black" />
        </g>
        <defs>
            <clipPath id="clip0_14850_9694">
            <rect width={14} height={14} fill="white" />
            </clipPath>
        </defs>
    </svg>

  )
}

export default SearchIcon;